export default __webpack_public_path__ + "static/media/aleo-v4-latin-regular.916ebac0.svg";